<template>
  <div class="animate__animated animate__fadeIn">
    <h4 class="h3 mb-3 text-gray-800">{{ $t("Cadastrar Programa") }}</h4>
    <form @submit.prevent="submit" ref="addItem">
      <div class="row">
        <form-input
          v-model="item.nome"
          grid="8"
          label="Nome do Programa"
          :required="true"
        />

        <form-input
          v-model="item.valor"
          grid="4"
          inputGroup="true"
          btnText="R$"
          :type="'number'"
          label="Valor"
          min="0"
        />

        <form-toggle
          grid="12"
          mt="0"
          v-model="item.gerenciado"
          label="Deseja fazer a gestão dos pagamentos deste programa?"
        />

        <form-input
          v-if="item.gerenciado"
          v-model="item.dia_pagamento"
          grid="4"
          label="Dia do mês para pagamento"
          :type="'number'"
        />
        <form-input
          v-if="item.gerenciado"
          v-model="item.num_parcelas"
          grid="4"
          label="Parcelas"
          :type="'number'"
        />

        <form-select
          v-if="item.gerenciado"
          v-model="item.origem"
          grid="4"
          label="Fonte do Recurso"
          :itens="$root.arrays.origem_beneficio"
        />

        <form-textarea-editor
          v-model="item.observacoes"
          label="Mais detalhes sobre o Programa"
        />
      </div>

      <div class="row pt-4 px-0 d-flex justify-content-end">
        <div class="col-auto px-2 text-right">
          <a class="btn btn-default" @click="$emit('voltar')">
            <i class="mdi mdi-arrow-left" />
          </a>
          <button
            class="btn btn-success btn-submit"
            data-style="zoom-in"
            type="submit"
          >
            <i class="mdi mdi-content-save" />
            {{ $t("Salvar") }}
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  name: "AddProgramaSocial",
  data() {
    return {
      item: {},
      campoExtra: false,
    };
  },
  methods: {
    submit() {
      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      axios
        .post("api/dashboard/programassociais", this.item)
        .then((response) => {
          ladda.stop();
          this.$snack.success({
            button: false,
            text: response.data.data.message,
          });
          this.$emit("voltar");
          this.$emit("reload");
        });
    },
  },
};
</script>

<style>
</style>
